/* Troca a foto do card ao passar o mouse na bolinha de cor do grupo. */
(function () {
  function primaryImage(card) {
    return card.querySelector('.product-card__image--primary');
  }

  function secondaryImage(card) {
    return card.querySelector('.product-card__image--secondary');
  }

  document.addEventListener('mouseover', function (event) {
    if (!event.target || !event.target.closest) return;

    var swatch = event.target.closest('.mt-grupo-cores__item');
    if (!swatch) return;

    var card = swatch.closest('product-card');
    if (!card) return;

    var image = primaryImage(card);
    if (!image) return;

    var preview = swatch.getAttribute('data-mt-preview');
    if (!preview) return;

    if (image.dataset.mtOriginalSrc === undefined) {
      image.dataset.mtOriginalSrc = image.getAttribute('src') || '';
      image.dataset.mtOriginalSrcset = image.getAttribute('srcset') || '';
    }

    image.setAttribute('srcset', '');
    image.setAttribute('sizes', '');
    image.setAttribute('src', preview);

    // Esconde a segunda foto (a que o tema mostra no hover) para a cor escolhida aparecer
    var secondary = secondaryImage(card);
    if (secondary) {
      secondary.style.opacity = '0';
    }
  });

  document.addEventListener(
    'mouseleave',
    function (event) {
      var card = event.target;
      if (!card || !card.tagName || card.tagName !== 'PRODUCT-CARD') return;

      var secondary = secondaryImage(card);
      if (secondary) {
        secondary.style.opacity = '';
      }

      var image = primaryImage(card);
      if (!image || image.dataset.mtOriginalSrc === undefined) return;

      image.setAttribute('src', image.dataset.mtOriginalSrc);
      image.setAttribute('srcset', image.dataset.mtOriginalSrcset);
    },
    true
  );
})();
